import { v4 as uuidv4 } from 'uuid';
import { trackPageVisit } from '../firebase/firestore';

export const getSessionId = () => {
  let sid = sessionStorage.getItem('news_session_id');
  if (!sid) {
    sid = uuidv4();
    sessionStorage.setItem('news_session_id', sid);
  }
  return sid;
};

export const trackVisit = async ({ pageType, pageURL, articleId = null, epaperDate = null }) => {
  const sessionId = getSessionId();
  try {
    await trackPageVisit({ sessionId, pageType, pageURL, articleId, epaperDate });
  } catch (e) {
    console.warn('Tracking failed:', e);
  }
};
